import React from 'react';
import PropTypes from 'prop-types';

import './styles.css';

function ProgressBar({
  vertical, completed, className, ...props
}) {
  const dimension = vertical ? 'height' : 'width';

  return (
    <div
      className={`ProgressBar ${vertical ? 'ProgressBar--vertical ' : ''}${className || ''}`}
      {...props}
    >
      <div
        className="ProgressBar__completed"
        style={{ [dimension]: `${completed}%` }}
      />
    </div>
  );
}

ProgressBar.propTypes = {
  vertical: PropTypes.bool,
  completed: PropTypes.number,
  className: PropTypes.string,
};

export default ProgressBar;
